import _typeof from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/typeof";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import "codemirror/theme/blackboard.css";
import "codemirror/lib/codemirror.css";
import "codemirror/addon/hint/show-hint.css";

var CodeMirror = require("codemirror/lib/codemirror");

require("codemirror/addon/edit/matchbrackets");

require("codemirror/addon/selection/active-line");

require("codemirror/addon/hint/show-hint");

export default {
  name: "codeMirror",
  data: function data() {
    return {
      id: Math.floor(Math.random() * 100),
      editor: {},
      create: false,
      code: ''
    };
  },
  props: {
    visible: Boolean,
    type: String,
    value: {
      type: [String, Object, Array],
      default: ''
    }
  },
  watch: {
    visible: function visible(val) {
      var _this = this;

      if (val & !this.create) {
        this.create = true;
        this.$nextTick(function () {
          _this.init();

          _this.setValue(_this.code);
        });
      }
    },
    value: {
      handler: function handler(val) {
        var _this2 = this;

        if (['object', 'array'].includes(_typeof(val))) {
          this.code = JSON.stringify(this.value, null, 4);
        } else {
          this.code = val;
        }

        this.$nextTick(function () {
          _this2.setValue(_this2.code);
        });
      },
      deep: true
    }
  },
  methods: {
    handleClose: function handleClose() {
      this.setVisible(false);
    },
    submit: function submit() {
      var value = this.getValue();

      if (this.validatenull(value)) {
        value = '{}';
      }

      try {
        if (['query', 'data'].includes(this.type)) {
          value = JSON.parse(value, null, 4);
        }

        this.$emit('submit', value);
        this.setVisible(false);
      } catch (error) {
        this.$message.error('数据格式有误');
      }
    },
    getValue: function getValue() {
      return this.editor.getValue();
    },
    setVisible: function setVisible(val) {
      this.$emit('update:visible', val);
    },
    setValue: function setValue() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (this.editor) this.editor.setValue(val);
    },
    init: function init() {
      var _this3 = this;

      var mime = 'text/javascript';
      var theme = 'blackboard'; //设置主题，不设置的会使用默认主题

      this.editor = CodeMirror.fromTextArea(this.$refs[this.id], {
        mode: mime,
        //选择对应代码编辑器的语言，我这边选的是数据库，根据个人情况自行设置即可
        indentWithTabs: true,
        smartIndent: true,
        lineNumbers: true,
        matchBrackets: true,
        theme: theme,
        // autofocus: true,
        extraKeys: {
          'Ctrl': 'autocomplete'
        } //自定义快捷键
        // hintOptions: {//自定义提示选项
        //   tables: {
        //     users: ['name', 'score', 'birthDate'],
        //     countries: ['name', 'population', 'size']
        //   }
        // }

      }); //代码自动提示功能，记住使用cursorActivity事件不要使用change事件，这是一个坑，那样页面直接会卡死

      this.editor.on('cursorActivity', function () {
        _this3.editor.showHint();
      });
    }
  }
};